import { motion } from "framer-motion";
import { Users, Sun, Moon, Sunset, ChevronRight } from "lucide-react";

export default function SceneCard({ scene, characters, isSelected, onClick }) {
  const sceneCharacters = characters.filter(c =>
    scene.characters?.some(sc => sc.toLowerCase() === c.name.toLowerCase())
  );

  const isExterior = scene.type?.includes('EXT');
  const TimeIcon = scene.time_of_day?.toLowerCase().includes('night') ? Moon
               : scene.time_of_day?.toLowerCase().includes('evening') ? Sunset
               : Sun;

  return (
    <motion.div
      onClick={onClick}
      whileHover={{ x: 2 }}
      className={`p-4 bg-[var(--bg-elevated)] border border-[var(--border-subtle)] rounded-xl cursor-pointer transition-all ${
        isSelected ? 'border-[var(--color-gold-500)] bg-[rgba(212,168,75,0.06)]' : 'hover:border-[var(--border-default)]'
      }`}
      data-testid={`scene-card-${scene.number}`}
    >
      <div className="flex items-start gap-4">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
          isExterior
            ? 'bg-gradient-to-br from-sky-900/50 to-emerald-900/30'
            : 'bg-gradient-to-br from-amber-900/50 to-orange-900/30'
        }`}>
          <span className="text-sm font-bold text-white/80">{scene.number}</span>
        </div>

        <div className="flex-1 min-w-0 overflow-hidden">
          <p className="text-sm font-medium text-[var(--text-primary)] leading-snug line-clamp-2" title={scene.heading || `Scene ${scene.number}`}>
            {scene.heading || `Scene ${scene.number}`}
          </p>
          <div className="flex items-center gap-3 mt-2 text-xs text-[var(--text-muted)]">
            {scene.time_of_day && (
              <span className="flex items-center gap-1 flex-shrink-0">
                <TimeIcon size={12} />
                {scene.time_of_day}
              </span>
            )}
            {sceneCharacters.length > 0 && (
              <span className="flex-shrink-0">{sceneCharacters.length} chars</span>
            )}
          </div>
        </div>

        <ChevronRight size={16} className={`flex-shrink-0 mt-2 text-[var(--text-disabled)] ${isSelected ? 'text-[var(--color-gold-400)]' : ''}`} />
      </div>
    </motion.div>
  );
}
